import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'goalStrategy',
  initialState: {
    items: [],
    target: null,
    loading: false,
  },
  reducers: {
    setGoalStrategies(state, { payload: { items } }) {
      state.items = items;
    },
    setTargetGoalStrategy(state, { payload: { target } }) {
      state.target = target;
    },
  },
});

export const {
  setGoalStrategies,
  setTargetGoalStrategy,
} = slice.actions;

export default slice.reducer;
